import { Component, OnInit, Input, EventEmitter, Output, ElementRef } from "@angular/core";
import { DataRowComponent } from "../../_component/pagination-client-side/data-row.component";
import { Platform } from "@ionic/angular";
import { DictionaryService } from "src/app/dictionary/dictionary.service";
import { ThisPlatform } from "src/app/_services/platform.service";
import { validEvents } from "@tinymce/tinymce-angular/editor/Events";

@Component({
  selector: "app-report-view",
  templateUrl: "./report-view.component.html",
  styleUrls: [
    "./report-view.component.scss",
    "./../../../_styles/ion-grid-content-table.scss",
  ],
})
export class ReportViewComponent implements OnInit, DataRowComponent {
  constructor(
    public dictionaryServ: DictionaryService,
    public p: ThisPlatform,
    private elementRef: ElementRef
  ) {}

  mobile = false;

  @Input()
  row: any;

  @Input()
  customData: string;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    this.setType();
  }

  setType(){
    const value = this.dictionaryServ.getDictionaryValueColor(
      this.dictionaryServ.reportPriorityValues,
      this.row.priority);

    this.elementRef.nativeElement.style.setProperty("--flag-color", value);
  }
}
